import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { selectIsNightMode, toggleMode } from '../../../redux/slices/modeSlice';
import { getAuthLocalStorage } from '../../../storage/localStorage';
import AdminSidebar from '../adminSidebar';
import AdminHeader from '../adminHeader';
import './adminLayout.css';

export default function AdminLayout({ children }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const isNightMode = useSelector(selectIsNightMode);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  // Only redirect sellers to seller dashboard (admins stay here)
  useEffect(() => {
    const auth = getAuthLocalStorage();
    const userType = (auth?.userType || localStorage.getItem('userType') || '').toLowerCase();
    
    // Sellers should use SellerLayout via SmartLayout, redirect if they somehow end up here
    if (userType === 'seller') {
      navigate('/seller/dashboard', { replace: true });
    }
  }, [navigate]);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 1024;
      setIsMobile(mobile);
      if (!mobile) {
        setMobileMenuOpen(false);
      }
    };

    handleResize(); // Check on mount
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMenuClick = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleDarkModeToggle = () => {
    dispatch(toggleMode());
  };

  // Check if user has access to admin layout
  const auth = getAuthLocalStorage();
  const userType = (auth?.userType || localStorage.getItem('userType') || '').toLowerCase();
  
  // Sellers should use SellerLayout, not AdminLayout
  if (userType === 'seller') {
    return null; // Will redirect in useEffect
  }

  // Calculate margin for main content
  const getMainMargin = () => {
    if (isMobile) return '0';
    return sidebarCollapsed ? '80px' : '240px';
  };

  return (
    <div className="kiro-admin-layout">
      <AdminSidebar
        collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed}
        mobileOpen={mobileMenuOpen}
        setMobileOpen={setMobileMenuOpen}
      />
      
      <main className="kiro-admin-main" style={{ marginLeft: getMainMargin() }}>
        <AdminHeader
          onMenuClick={handleMenuClick}
          darkMode={isNightMode}
          setDarkMode={handleDarkModeToggle}
        />
        
        <div className="kiro-admin-content">
          <div className="kiro-page-container">
            {children}
          </div>
        </div>
      </main>
    </div>
  );
}
